module.exports = "<dynamic-table rows=\"gridRows\" columns=\"gridColumns\" items-per-page=\"options.itemsPerPage\"></dynamic-table>\n"